import axios from "axios";
import UserApiRoute from "user/UserApiRoute";
import PartnerProfile, { AccountTypeKey } from "./PartnerProfile";
import SearchPartnerFilters from "./SearchPartnerFilters";
import FindAllProfilesResponse from "./FindAllProfilesResponse";
import ClientProfile from "../client/ClientProfile";
import Appointment from "../../booking/Appointment";
import EditClientProfileRequestBody from "user/client/EditClientProfileRequestBody";
import RegisterUserResponse from "../RegisterUserResponse";

export interface ErrorResponse {
  status: number;
  message: string;
}

export default class PartnerProfileApi {
  async findById(id: string) {
    const response = await axios.get<PartnerProfile>(
      `${UserApiRoute.PROFILE}/${id}`
    );
    return response.data;
  }

  async search(form: SearchPartnerFilters) {
    const response = await axios.post<FindAllProfilesResponse>(
      UserApiRoute.PROFILE_SEARCH,
      form
    );
    return response.data;
  }

  async getByUserId(
    userId: string,
    accountType: AccountTypeKey
  ): Promise<PartnerProfile> {
    const response = await axios.get(
      `${UserApiRoute.PROFILE}/${accountType}/${userId}?userId=${userId}`
    );
    return response.data;
  }

  async getClientProfileById(userId: string): Promise<ClientProfile> {
    const response = await axios.get(
      `${UserApiRoute.PROFILE}/client/${userId}?userId=${userId}`
    );
    return response.data;
  }

  async getPublicByResourceId(id: string): Promise<PartnerProfile> {
    const response = await axios.get(`${UserApiRoute.PROFILE}/public/${id}`);
    return response.data;
  }

  async getFuturePartnerAppointments(
    partnerId: string
  ): Promise<Appointment[]> {
    const id = encodeURIComponent(partnerId);
    const response = await axios.get(
      `${UserApiRoute.PROFILE}/partner/appointment/all-future/${id}`
    );
    return response.data;
  }

  async createClientProfile(
    userId: string,
    form: EditClientProfileRequestBody
  ): Promise<RegisterUserResponse> {
    const response = await axios.post(
      `${UserApiRoute.PROFILE}/client/${userId}?userId=${userId}`,
      form
    );
    return response.data;
  }

  async updateClientProfile(
    userId: string,
    form: EditClientProfileRequestBody
  ): Promise<RegisterUserResponse> {
    const response = await axios.put(
      `${UserApiRoute.PROFILE}/client/${userId}?userId=${userId}`,
      form
    );
    return response.data;
  }

  async deleteByUserId(userId: string) {
    return axios.delete(
      `${UserApiRoute.PROFILE}/partner/${userId}?userId=${userId}`
    );
  }
}
